import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { TravelReimbursementService } from '../../services/travel-reimbursement.service';
import { Travel } from 'src/app/models/travel';
import { reimbursementUrl, travelAuthorUrl } from 'src/app/modules/shared/common/api';

@Component({
  selector: 'app-travel-reimbursement-approve-list',
  templateUrl: './travel-reimbursement-approve-list.component.html',
  styleUrls: ['./travel-reimbursement-approve-list.component.scss']
})
export class TravelReimbursementApproveListComponent implements OnInit {

  keyWords = [];
  isNoResult: boolean = false;
  loading:boolean = false;
  isKeyWord:boolean = false;
  keyTable = '';

  totalRec : number;
  page: number = 1;
  perPage: number;

  travel: any;
  dialogConfig:any;
  formGroup: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<TravelReimbursementApproveListComponent>,
    public liquidationService: TravelReimbursementService
  ) { }

  ngOnInit() {
    this.getList();
  }

  getSelect(res){
    this.dialogRef.close(res);
  }

  getList() {
    let param = [];
    let queryString = '';

    param.push('type=for-reimbursement');

    if (this.page) {
      param.push('page='+this.page);
    }
  
    if (param.length) {
      queryString = '?' + param.join('&');
    }

    this.loading = true;
    this.isNoResult = false;
    this.liquidationService.url = travelAuthorUrl+'/lookup'+ queryString;
    this.liquidationService.getFilter().subscribe(res=>{
      if (res.data.length) {
        this.travel = new Travel(res.data);
      } else {
        this.isNoResult = true;
      }
      this.totalRec = res.total;
      this.perPage = res.per_page;
      this.loading = false;
      if (res.total == 0) {
        this.isNoResult = true;
      }
    });
  }

  closeOnClick() {
    this.dialogRef.close('');
  }

  pageChange(newPage: number) {
    this.page = newPage;
    this.getList();
		return false;
  }


}
